'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index$1 = require('../../../node_modules/classnames/index.js');

var index = require('../../../node_modules/prop-types/index.js');

require('../../../primitives/Button/Button.js');

require('../../../primitives/Hero/Hero.js');

var Icon = require('../../../primitives/Icon/Icon.js');

require('../../../primitives/Link/Link.js');

require('../../../composites/Alert/Alert.js');

require('../../../composites/AlertBanner/AlertBanner.js');

require('../../../composites/Banner/Banner.js');

require('../../../composites/Card/Card.js');

require('../../../composites/Card/CardBody/CardBody.js');

require('../../../composites/Card/CardImage/CardImage.js');

require('../../../composites/Card/CardText/CardText.js');

require('../../../composites/Card/CardTitle/CardTitle.js');

require('../../../composites/Video/Video.js');

require('../../../composites/CardCarousel/CardCarousel.js');

require('../../../composites/Carousel/Carousel.js');

require('../../../composites/Carousel/CarouselControl/CarouselControl.js');

require('../../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');

require('../../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');

require('../../../composites/Carousel/CarouselItem/CarouselItem.js');

require('../../../composites/Carousel/CarouselInner/CarouselInner.js');

require('../../../composites/FeatureCarousel/FeatureCarousel.js');

require('../../../composites/FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');

require('../../../composites/FeaturedMarquee/FeaturedMarquee.js');

require('../../../composites/Modal/Modal.js');

require('../../../composites/Modal/ModalBody/ModalBody.js');

require('../../../composites/Modal/ModalFooter/ModalFooter.js');

require('../../../composites/Modal/ModalHeader/ModalHeader.js');

require('../../../composites/PanelGroup/PanelGroup.js');

require('../../../composites/PanelGroup/Panel/Panel.js');

require('../../../composites/PodcastCard/PodcastCard.js');

require('../../../composites/PodcastCarousel/PodcastCarousel.js');

var SearchBar = require('../../../composites/SearchBar/SearchBar.js');

require('../../../composites/SplitBanner/SplitBanner.js');

require('../../../composites/SplitBanner/SplitBannerImage/SplitBannerImage.js');

require('../../../composites/SplitBanner/SplitBannerVideo/SplitBannerVideo.js');

require('../../../composites/SplitBanner/SplitBannerContent/SplitBannerContent.js');

var NavMobileDropdown = require('../NavMobileDropdown/NavMobileDropdown.js');

require('../../../node_modules/gatsby-link/index.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var NavMobile = function NavMobile(props) {
  var className = props.className,
      activeNavItem = props.activeNavItem,
      navData = props.navData;
  var primaryNavData = navData.primaryNavData,
      quickLinksNavData = navData.quickLinksNavData;

  var _useState = React.useState(null),
      _useState2 = slicedToArray['default'](_useState, 2),
      activeQuickLink = _useState2[0],
      setActiveQuickLink = _useState2[1];

  var navmobileClasses = index$1['default']('navmobile', className, 'lanl-navmobile', activeNavItem ? 'lanl-navmobile--active' : '');
  var navmobiledrawerClasses = index$1['default']('navmobile-drawer', activeQuickLink ? 'navmobile-drawer--active' : '');
  React.useEffect(function () {
    var body = document.querySelector('body');

    if (activeNavItem && body) {
      body.classList.add('no-scroll');
    } else {
      body.classList.remove('no-scroll');
    }
  }, [activeNavItem]);

  var getMenuCatagories = function getMenuCatagories(menuItems) {
    return menuItems.map(function (_ref) {
      var groupName = _ref.groupName,
          link = _ref.link,
          groupItems = _ref.groupItems;
      var groupItemsList = groupItems.map(function (_ref2) {
        var name = _ref2.name,
            link = _ref2.link;
        return /*#__PURE__*/React__default['default'].createElement("li", {
          key: "dropdown-link-".concat(name)
        }, /*#__PURE__*/React__default['default'].createElement("a", {
          href: link
        }, name));
      });
      return /*#__PURE__*/React__default['default'].createElement(NavMobileDropdown.NavMobileDropdown, {
        key: "mobile-dropdown-".concat(groupName),
        name: groupName,
        link: link,
        menuItems: groupItems,
        secondary: true
      }, /*#__PURE__*/React__default['default'].createElement("ul", {
        className: "dropdown-group-list"
      }, groupItemsList));
    });
  };

  var renderPrimaryMenuItems = function renderPrimaryMenuItems() {
    return primaryNavData.map(function (_ref3) {
      var name = _ref3.name,
          link = _ref3.link,
          menuItems = _ref3.menuItems;
      return /*#__PURE__*/React__default['default'].createElement(NavMobileDropdown.NavMobileDropdown, {
        key: "mobile-dropdown-".concat(name),
        name: name,
        link: link,
        menuItems: menuItems
      }, /*#__PURE__*/React__default['default'].createElement("ul", null, getMenuCatagories(menuItems)));
    });
  };

  var renderQuickLinkMenuItems = function renderQuickLinkMenuItems() {
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("li", {
      className: "quicklinks-mobile-item is-link",
      onClick: function onClick() {
        window.location.replace('https://discover.lanl.gov/');
      }
    }, "News & Media"), /*#__PURE__*/React__default['default'].createElement("li", {
      className: "quicklinks-mobile-item is-link",
      onClick: function onClick() {
        window.location.replace('https://www.lanl.jobs/');
      }
    }, "Careers"), quickLinksNavData.map(function (_ref4, i) {
      var name = _ref4.name;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: "quicklinks-mobile-".concat(i),
        className: "quicklinks-mobile-item",
        onClick: function onClick() {
          return setActiveQuickLink(name);
        }
      }, name, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
        icon: "chevron-right",
        size: "xs",
        className: "ms-2"
      }));
    }));
  };

  var renderActiveQuickLinkItems = function renderActiveQuickLinkItems() {
    var linkData = quickLinksNavData.find(function (item) {
      return item.name === activeQuickLink;
    });

    if (linkData) {
      return linkData.items.map(function (_ref5) {
        var name = _ref5.name,
            link = _ref5.link;
        return /*#__PURE__*/React__default['default'].createElement("li", {
          key: "drawer-link-".concat(name),
          className: "drawer-item"
        }, /*#__PURE__*/React__default['default'].createElement("a", {
          href: link
        }, name));
      });
    } else {
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: navmobileClasses,
    "data-testid": "lanl-navmobile"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "search-container"
  }, /*#__PURE__*/React__default['default'].createElement(SearchBar.SearchBar, {
    active: true
  })), /*#__PURE__*/React__default['default'].createElement("ul", null, renderPrimaryMenuItems(), renderQuickLinkMenuItems())), /*#__PURE__*/React__default['default'].createElement("div", {
    className: navmobiledrawerClasses,
    "data-testid": "lanl-navmobile-drawer"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "drawer-close",
    onClick: function onClick() {
      return setActiveQuickLink(null);
    }
  }, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
    icon: "chevron-left",
    size: "sm",
    className: "me-2"
  }), "Back"), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "drawer-item-container"
  }, renderActiveQuickLinkItems())));
};

NavMobile.defaultProps = {};
NavMobile.propTypes = {
  activeNavItem: index['default'].string,
  className: index['default'].string,
  navData: index['default'].object
};
exports.NavMobile = NavMobile;
exports['default'] = NavMobile;